import type { OwnFxTransfer } from './OwnFxTransfer';

export const base: OwnFxTransfer = {
    enabled: false,
    _description: 'Enables Own FX Transfer feature',
};
